
<template>
  <!-- 服务订单详情 -->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
                <a-form-item class="value-indent" :label="item.label">
                  <span class="ant-form-text">{{item.value}}</span>
                </a-form-item>
              </a-col>
          </a-row>
        </div>
      </div>

      <div class="card" v-if="serveInfos.businessType == 1">
        <div class="card-head">
          <h3>服务详情</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col :span="8">
                <a-form-item class="value-indent" label="服务地址">
                  <span class="ant-form-text">{{serveInfos.address}}</span>
                </a-form-item>
              </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-for="(item, index) of serveInfos.orderServiceInfoVO" :key="index" :span="8">
                <a-form-item class="value-indent" :label="item.postName">
                  <div>
                    <span v-for="(takecode, takecodeIndex) of item.takecode" :key="takecodeIndex" style="inline-block;white-space:nowrap">
                        <span style="width:74px;display:inline-block;margin-left:8px;">取件码{{takecodeIndex+1}}:</span>
                        <span style="width:180px;display:inline-block">{{takecode}}</span>
                        <div v-if ="(takecodeIndex+1)%2==0"></div>
                    </span>
                  </div>
                </a-form-item>
              </a-col>
          </a-row>
        </div>
      </div>

      <div class="card" v-if="serveInfos.businessType == 2">
        <div class="card-head">
          <h3>服务详情</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col :span="8">
                <a-form-item class="value-indent" label="服务地址">
                  <span class="ant-form-text">{{serveInfos.address}}</span>
                </a-form-item>
              </a-col>
          </a-row>
          <a-row type="flex">
            <a-col v-for="(item, index) of serveInfoB" :key="index" :span="8">
                <a-form-item class="value-indent" :label="item.label">
                  <span class="ant-form-text">{{item.value}}</span>
                </a-form-item>
              </a-col>
          </a-row>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>订单信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of orderInfo" :key="index" :span="8">
                <a-form-item class="value-indent" :label="item.label">
                  <span class="ant-form-text">{{item.value}}</span>
                </a-form-item>
              </a-col>
          </a-row>
        </div>
      </div>

    </a-form>
  </div>
</template>

<script>
export default {
  name: 'serviceOrderDetails',
  data () {
    return {
      id: undefined,
      baseInfo: [
        {key: 'nickName', label: '昵称', value: ''},
        {key: 'mobile', label: '手机号', value: ''},
        {key: 'orderStatusDesc', label: '订单状态', value: ''},
        {key: 'shopName', label: '服务网点', value: ''},
        {key: 'businessTypeDesc', label: '服务类型', value: ''}
      ],
      orderInfo: [
        {key: 'orderId', label: '订单号', value: ''},
        {key: 'createTime', label: '下单时间', value: ''},
        {key: 'payTime', label: '付款时间', value: ''},
        {key: 'goodsNums', label: '数量', value: ''},
        {key: 'verifyFee', label: '单价', value: ''},
        {key: 'totalFee', label: '合计', value: ''},
        {key: 'platformVoucherAmount', label: '平台优惠', value: ''},
        {key: 'payFee', label: '实付', value: ''},
        {key: 'rufundFee', label: '退款金额', value: ''},
        {key: 'startRefundTime', label: '退款发起时间', value: ''},
        {key: 'endRefundTime', label: '退款成功时间', value: ''}
      ],
      serveInfo: [
        {key: 'businessType', label: '业务类型', value: ''},
        {key: 'address', label: '服务地址', value: ''},
        {key: 'orderServiceInfoVO', label: '驿站信息', value: ''}
      ],
      serveInfoB: [
        {key: 'buyTypeDesc', label: '购买类型', value: ''},
        {key: 'throwingTimeDesc', label: '代扔时间', value: ''},
        {key: 'startTime', label: '服务开始时间', value: ''}
      ],
      serveInfos: {}
    };
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    document.getElementsByClassName('layout-content')[0].style.backgroundColor = '#fff';
    next();
  },
  filters: {
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  created () {
    this.getDetail();
  },
  methods: {
    getDetail () {
      this.$get({
        url: `/housekeep/order/${this.$route.query.id}`, //
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
          this.orderInfo.forEach((el) => {
            if (el.key === item) {
              if (el.label == '单价' || el.label == '合计' || el.label == '实付' || el.label == '退款金额' || el.label == '平台优惠') {
                el.value = data[item] && ('￥' + data[item]) || '￥0';
              } else {
                el.value = data[item];
              }
            }
          });
          this.serveInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
              this.serveInfos[item] = data[item];
            }
          });
          this.serveInfoB.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
      });
    }
  }
};
</script>
<style scoped >
.pic-box{
  width:200px;
  height: 70px;
  max-height: 70px;
  overflow: hidden;
}
.pic-box img{
  height: 70px;
  width: auto !important;
  max-height: 70px;
}
  .card{
    margin-bottom:24px;
  }
</style>
